export default __webpack_public_path__ + "static/media/highlight-5.81f45ecb.jpg";